import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const StyledCard = styled.div`
  border: 1px solid #e3e1e1;
  border-radius: 4px;
  background: #fff;
  padding: 24px;
  margin-bottom: 10px;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #4b4d4f;
  margin: 0 0 32px 0;
`;

const Card = ({ title, children }) => {
  return (
    <StyledCard>
      <Title>{title}</Title>
      {children}
    </StyledCard>
  );
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Card;
